import React from "react";

//UI Material
import {
  Card,
  Chip,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";

//Helpers
import {
  typographyForCustomizedFontSize,
  typographyForSubtitles,
} from "../../Helpers/typography";

//Material Icons
import { Build, Troubleshoot } from "@mui/icons-material";

export default function ColaboratorsList({ data = [], users = [] }) {
  // ==========> Component Functions <==========
  //Function to get the count of assembly/tested products by user
  const getCountByUser = (user, key) => {

    const targetUser = users.find((u) => u.user === user);

    return data.reduce((count, item) => {
      //producto[assemblyBy]
      if (item[key] && targetUser.email === item[key]) {
        return count + 1;
      }
      return count;
    }, 0);
  };

  //Function to get the last registered interaction by user
  const getUserLastInteraction = (email) => {
    
    const targetUser = users.find((user) => user.email === email);

    let userData = data.filter(
      (i) =>
        i.assemblyBy === targetUser.email ||
        (i.testedBy && i.testedBy === targetUser.email)
    );

    if (userData.length === 0) {
      return "Sin registros";
    }

    const assemblyDates = userData.map((item) => new Date(item.assemblyAt));
    const testedDates = userData
      .filter((item) => item.testedBy)
      .map((item) => new Date(item.testedAt));

    const allDates = assemblyDates.concat(testedDates);
    const lastDate = new Date(Math.max(...allDates));

    return lastDate.toLocaleDateString();
  };

  // ==========> Component <==========
  return (
    <Card raised>
      <Grid container sx={{ padding: "10px" }} spacing={1}>
        <Grid item xs={12}>
          {typographyForSubtitles("Resultados de colaboradores", "secondary")}
        </Grid>
        <Grid item xs={12}>
          <TableContainer>
            <Table aria-label="production-table">
              <TableHead>
                <TableRow>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Nombre del colaborador",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Productos ensamblados",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Productos probados",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                  <TableCell align="center">
                    {typographyForCustomizedFontSize(
                      "Última interacción",
                      "11px",
                      null,
                      "bold"
                    )}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {users
                  .filter((u) => u.role !== "ADMINISTRATOR")
                  .sort((a, b) => {
                    if (a.user < b.user) return -1;
                    if (a.user > b.user) return 1;
                    return 0;
                  })
                  .map((u) => (
                    <TableRow key={u.user}>
                      <TableCell align="center">{u.user}</TableCell>
                      <TableCell align="center">
                        <Chip
                          icon={<Build />}
                          variant="outlined"
                          label={getCountByUser(u.user, "assemblyBy")}
                        />
                      </TableCell>
                      <TableCell align="center">
                        <Chip
                          icon={<Troubleshoot />}
                          variant="outlined"
                          label={getCountByUser(u.user, "testedBy")}
                        />
                      </TableCell>
                      <TableCell align="center">
                        {getUserLastInteraction(u.email)}
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Grid>
      </Grid>
    </Card>
  );
}
